/**
 * Database type.
 */
export type DatabaseType =
    "mysql"|
    "postgres"|
    "cockroachdb"|
    "mariadb"|
    "sqlite"|
    "cordova"|
    "react-native"|
    "nativescript" |
    "sqljs"|
    "oracle"|
    "mssql"|
    "mongodb"|
    "aurora-data-api"|
    "expo";
